import { Category } from "./category";
import { JsonProperty } from "../requests/jsonparser";
import { Curated } from "./curated";

export default class CuratedCategory extends Category {

    @JsonProperty({ type: 'Curated', clazz: Curated })
    sets: Curated[];
}


// WEBPACK FOOTER //
// ./src/api/src/models/curated_category.ts